'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _pick = require('lodash/pick');

var _pick2 = _interopRequireDefault(_pick);

var _BaseError2 = require('./BaseError');

var _BaseError3 = _interopRequireDefault(_BaseError2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var requestParamsToLog = ['method', 'url', 'params', 'timeout'];

var responseParamsToLog = ['data', 'status', 'statusText'];

var ApiError = function (_BaseError) {
  _inherits(ApiError, _BaseError);

  function ApiError(apiDetails) {
    _classCallCheck(this, ApiError);

    // In the case of a Network Error, response will be undefined as there is no response. We'll
    // need to get the request details differently.
    var _this = _possibleConstructorReturn(this, (ApiError.__proto__ || Object.getPrototypeOf(ApiError)).call(this, apiDetails.message || (0, _get2.default)(apiDetails, 'response.statusText')));

    var request = (0, _get2.default)(apiDetails, 'response.config') || apiDetails.config;

    _this.request = request && (0, _pick2.default)(request, requestParamsToLog);
    _this.response = apiDetails.response && (0, _pick2.default)(apiDetails.response, responseParamsToLog);

    // There are some cases where we do not want to include the status code (e.g. when we're
    // throwing an ApiError for when an API response comes back with unexpected or missing data,
    // but the response itself is a 2XX response). The status code is recorded with the response
    // object anyway, so we still log it.
    if (!apiDetails.doNotIncludeStatus && apiDetails.response) {
      _this.statusCode = apiDetails.response.status;
    }
    return _this;
  }

  return ApiError;
}(_BaseError3.default);

exports.default = ApiError;
//# sourceMappingURL=ApiError.js.map